<template>
    <div class="a-checkboxesGroup">
        <div class="filter-title d-flex align-items-center mb-1">
            <h5 class="filter-title mb-0" v-text="filter.groupTitle" />

            <filter-label
                v-if="text"
                :text="text.toString()"
                :background-color="filter.backgroundColor"
                :color="filter.color"
                class="text-uppercase ml-3 mr-auto"
                @close="clearFilterGroup(filter.groupName)"
                @click.stop.native
            />
        </div>

        <ui-checkbox-input
            v-for="(filter, filterKey, idxx) in filter.filters"
            :key="idxx"
            :label="filter.text"
            :name="filterKey"
            :value="filter.value"
            :tooltip="filter.tooltip"
            @change="$emit('set-filter-by-key', {
                key: filterKey,
                value: $event
            })"
        />
    </div>
</template>

<script>
import filterMixin from './filter.mixin'

export default {
    mixins: [filterMixin],

    props: {
        moduleName: {
            type: String,
            required: true
        }
    },
    computed: {
        text() {
            return Object.values(this.filter.filters).filter(el => el.value).length
        }
    },
    methods: {
        async clearFilterGroup() {
            const { moduleName } = this

            for (const [filter] of Object.entries(this.filter.filters)) {
                await this.$store.dispatch('setFilter', {
                    filter,
                    value: false,
                    moduleName
                })
            }

            this.$emit('apply-filters')
        }
    }
}
</script>